var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'z-form-item': true,
    'mb-0': _vm.reset_margin,
    'mh-60': _vm.reset_margin
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }